/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable react/button-has-type */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bool, string } from 'prop-types';
import get from 'lodash/get';
import classNames from 'classnames/bind';
import _isEmpty from 'lodash/isEmpty';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import Heartfill from 'yoda-core-components/lib/assets/svg/Heartfill.svg';
import Heart from 'yoda-core-components/lib/assets/svg/Heart.svg';
import SflError from 'yoda-core-components/lib/assets/svg/SflError.svg';
import Cookies from 'yoda-core-components/lib/helpers/Cookies/Cookies';
import Loader from 'yoda-core-components/lib/components/Loader/Loader';
import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';
import { findMobileOS } from 'yoda-core-components/lib/helpers/Utils/Utils';
import { selectIsNative } from '../../selectors/ContextSelector';
import { setDefaultOffSet, getScrolledElementOffSet } from '../../helpers/Utils/scrollPosition';
import { addItem, removeItem, resetStatus } from '../../actions/SavedItemAction';
import { cardTypes } from '../ProductCard/ProductCard.config';
import { triggerFormError } from '../../actions/AnalyticsAction';
import saveForLaterConfig from './SaveForLater.config';
import * as styles from './SaveForLater.css';
import { setOnWishListBeaconStatus } from '../../actions/CriteoAction';

const cx = classNames.bind(styles);

let SFLtimeout = null;
let prevInstance = null;

export const SaveForLater = ({
    cardType,
    isFirstProduct,
    ppId,
    skuId,
    OnWishlistBeacon,
    sponsoredProduct,
    productAnalyticsData = {},
}) => {
    const dispatch = useDispatch();
    const [mounted, setMounted] = useState(false);
    const [overlayText, setOverlayText] = useState(null);
    const [isInProgress, setIsInProgress] = useState(false);
    const isNative = useSelector((state) => selectIsNative(state));
    const deviceType = useSelector((state) => get(state?.context, 'deviceType', {}));
    const savedItemStatus = useSelector((state) => state.savedItemStatus);
    const savedItems = useSelector((state) => state.savedItems);
    const isSavedIn = savedItems && savedItems[ppId];
    const [isSaved, setIsSaved] = useState(!isSavedIn);
    const criteoData = useSelector((state) => get(state, 'criteo', {}));

    const { onWishlistBeaconCalledPPIDs = [] } = criteoData;
    const { productName = '', productImageSrc = '', productLink = '' } = productAnalyticsData;

    let canProcess = true;

    if (!mounted) {
        /* istanbul ignore next */
        if (!__SERVER__ && _isEmpty(savedItems) && !Cookies.load('FSFL') && isFirstProduct) {
            Cookies.save('FSFL', 'yes');
        }
    }

    useEffect(() => {
        setMounted(true);
    }, []);

    useEffect(() => {
        const savedItemStatusTest = (savedItemStatus || [])?.find((obj) => obj?.ppId === ppId);
        /* istanbul ignore next */
        if (savedItemStatusTest && canProcess) {
            if (savedItemStatusTest.isSuccess) {
                if (savedItemStatusTest.action === 'add') {
                    const addedText = (
                        <div>
                            <div className={cx('success')}>Added to Favorites</div>
                            <a className={cx('link')} href={saveForLaterConfig.url.SAVEDLISTFAV}>
                                View Favorites
                            </a>
                        </div>
                    );
                    setIsSaved(true);
                    setOverlayText(addedText);
                    /*
                    When multiple thumbnails are present, the following logic runs N times 
                    based on how many times ppId appears in the product list. 
                    
                    Checking for matching skuId reduces run count to just 1.
                    https://jcpdevtools.atlassian.net/browse/TOFP2P-4115
                    */
                    if (savedItemStatusTest?.skuId === skuId) {
                        isNative && findMobileOS() === 'iOS'
                            ? setDefaultOffSet(skuId, 'nativeGalleryScrollToOffSet')
                            : setDefaultOffSet(
                                  sponsoredProduct ? `${skuId}-sp` : skuId,
                                  'galleryFavoriteScrollTo'
                              );
                        LocalStorage.setData('galleryScrollToOffSet', getScrolledElementOffSet());
                    }
                } else if (savedItemStatusTest.action === 'remove') {
                    setIsSaved(false);
                    setOverlayText(null);
                }
            } else {
                const errorMessage =
                    savedItemStatusTest.errorMessage || 'Item could not be saved/removed';
                dispatch(
                    triggerFormError([
                        {
                            errorDescription: errorMessage.toLowerCase(),
                        },
                    ])
                );
                setOverlayText(
                    <div>
                        <div>
                            <Icon
                                iconType="svg"
                                automationId="save-for-later-automation-with-fil-error"
                                width="32px"
                                height="32px"
                                viewBox="0 0 32 32"
                                key="error"
                            >
                                <SflError />
                            </Icon>
                        </div>
                        <div className={cx('error')}>{errorMessage}</div>
                    </div>
                );
            }
            if (SFLtimeout && prevInstance !== canProcess) {
                prevInstance.resetStatusAndLabel();
                SFLtimeout = clearTimeout(SFLtimeout);
                prevInstance = null;
            }
            SFLtimeout = setTimeout(resetStatusAndLabel, 3000);
            prevInstance = canProcess;
            canProcess = false;
        }

        if (savedItems && (!savedItemStatusTest || _isEmpty(savedItemStatusTest))) {
            const isSavedItems = savedItems[ppId];
            /* istanbul ignore next */
            if (isSavedItems) {
                setIsSaved(true);
            } else if (isSaved) {
                setIsSaved(false);
            }
        }
    }, [savedItemStatus, savedItems]);

    const onHover = () => {
        if (isInProgress === false) {
            const fav = (savedItems || {})[ppId];
            const overlayTextHover = fav ? 'Remove Favorite' : 'Favorite';
            setOverlayText(overlayTextHover);
        }
    };

    const onLeave = () => {
        if (isInProgress === false) {
            setOverlayText(null);
        }
    };

    const resetStatusAndLabel = () => {
        /* istanbul ignore next */
        dispatch(resetStatus(ppId));
        resetLabel();
        canProcess = true;
    };

    const saveorDeleteItem = (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        if (isInProgress === false) {
            setOverlayText(<Loader automationId="test-automation-sfl-loader" />);
            setIsInProgress(true);
            const fav = (savedItems || {})[ppId];
            if (fav) {
                deleteItem(fav.id);
            } else {
                saveItem();
                if (OnWishlistBeacon) {
                    navigator.sendBeacon(`https:${OnWishlistBeacon}`);
                    dispatch(setOnWishListBeaconStatus(skuId));
                }
            }
        }
    };

    const saveItem = () => {
        dispatch(
            addItem([
                {
                    product: {
                        id: ppId,
                        productName,
                        productImageSrc,
                        productLink,
                    },
                    itemId: skuId,
                    quantity: 1,
                },
            ])
        );
    };

    const deleteItem = (id) => {
        dispatch(
            removeItem({
                ppId,
                id,
            })
        );
    };

    const resetLabel = () => {
        /* istanbul ignore next */
        setIsInProgress(false);
        setOverlayText(null);
    };

    const displayText = overlayText;
    const extraMargin = cardType === cardTypes.GRID ? 'extraMargin' : '';

    const tooltip = () => {
        if (displayText) {
            const tooltipClass =
                cardType === cardTypes.LIST ? 'saveTooltipRight' : 'saveTooltipBottom';
            return (
                <div className={cx(tooltipClass)}>
                    <div className={cx('tooltipContent')}>{displayText}</div>
                </div>
            );
        }

        return '';
    };
    const sflButtonKey = `saveForLater${ppId}${cardType}`;
    const savedIconKey = `saved${ppId}${cardType}`;
    const unsavedIconKey = `unsaved${ppId}${cardType}`;
    const windowWidth = !__SERVER__ && window.innerWidth;
    const { isDesktop } = deviceType;
    return (
        <div className={styles.saveForLater}>
            {isDesktop ? (
                <button
                    onClick={(e) => saveorDeleteItem(e)}
                    className={cx('sflButtonStyle', extraMargin)}
                    onMouseOver={() => onHover()}
                    onMouseLeave={() => onLeave()}
                    data-automation-id="save-for-later-btn"
                    key={sflButtonKey}
                >
                    {isSaved ? (
                        windowWidth && windowWidth >= 1440 ? (
                            <Icon
                                iconType="svg"
                                automationId="save-for-later-automation-with-fil"
                                width="32px"
                                height="32px"
                                viewBox="0 0 32 32"
                                key={savedIconKey}
                            >
                                <Heartfill />
                            </Icon>
                        ) : (
                            <Icon
                                iconType="svg"
                                automationId="save-for-later-automation-with-fil"
                                width="32px"
                                height="32px"
                                viewBox="0 0 32 32"
                                key={savedIconKey}
                            >
                                <Heartfill />
                            </Icon>
                        )
                    ) : windowWidth && windowWidth >= 1440 ? (
                        <Icon
                            iconType="svg"
                            automationId="save-for-later-automation"
                            width="32px"
                            height="32px"
                            viewBox="0 0 32 32"
                            key={unsavedIconKey}
                        >
                            <Heart />
                        </Icon>
                    ) : (
                        <Icon
                            iconType="svg"
                            automationId="save-for-later-automation"
                            width="32px"
                            height="32px"
                            viewBox="0 0 32 32"
                            key={unsavedIconKey}
                        >
                            <Heart />
                        </Icon>
                    )}
                </button>
            ) : (
                <button
                    onClick={(e) => saveorDeleteItem(e)}
                    className={cx('sflButtonStyle', extraMargin)}
                    data-automation-id="save-for-later-btn"
                    key={sflButtonKey}
                >
                    {isSaved ? (
                        <Icon
                            iconType="svg"
                            automationId="save-for-later-automation-with-fil"
                            width="28px"
                            height="28px"
                            viewBox="0 0 28 28"
                            key={savedIconKey}
                        >
                            <Heartfill />
                        </Icon>
                    ) : (
                        <Icon
                            iconType="svg"
                            automationId="save-for-later-automation"
                            width="28px"
                            height="28px"
                            viewBox="0 0 28 28"
                            key={unsavedIconKey}
                        >
                            <Heart />
                        </Icon>
                    )}
                </button>
            )}
            {tooltip()}
        </div>
    );
};

SaveForLater.propTypes = {
    cardType: string,
    isFirstProduct: bool,
    ppId: string,
    skuId: string,
};

SaveForLater.defaultProps = {
    cardType: cardTypes.GRID,
    isFirstProduct: false,
    ppId: null,
    skuId: null,
};

export default SaveForLater;
